const {Component, cloneElement} = require("react");
const HTML = require('html-parse-stringify');

class Trans extends Component {

  constructor(props) {
    super(props);
  }

  render () {

    let string = this.props.children;

    this.originalTags = [];

    if (Array.isArray(this.props.children)) {
      string = this.buildString(this.props.children);
    }

    let translatedString = translate(string, this.props.replace);

    if (this.originalTags.length > 0) {
      translatedString = this.rebuildTags(translatedString);
    }

    return translatedString;
  }

  buildString(stringParts) {
    let string = '';

    // Recursively build string with react elements omitted with replacements
    stringParts.forEach((stringPart, key) => {
      if (typeof stringPart === 'object') {
        this.originalTags.push(stringPart);

        string += `<${key}>`;

        if (Array.isArray(stringPart.props.children)) {
          string += this.buildString(stringPart.props.children);
        }
        else if (typeof stringPart.props.children === 'string') {
          string += stringPart.props.children;
        }

        string += `</${key}>`;
      }
      else {
        string += stringPart;
      }
    });

    return string;
  }

  rebuildTags(string) {
    let parsedString = HTML.default.parse(`<0>${string}</0>`);

    return this.buildTags(parsedString[0].children);
  }

  buildTags(elements) {
    let tags = [];

    // Recursively build array of tags with previously omitted react elements
    elements.forEach((element) => {

      if (element.type === 'text') {
        tags.push(element.content);
      }
      else if (element.type === 'tag') {
        let originalTagObject = this.originalTags[0];
        this.originalTags.shift();

        if (element.children.length > 0) {
          let translatedReactElement = cloneElement(originalTagObject, {key: tags.length}, this.buildTags(element.children));
          tags.push(translatedReactElement);
        }
        else {
          tags.push(originalTagObject);
        }
      }

    });

    return tags.length === 1 ? tags[0] : tags;
  }

}

module.exports = Trans;
